export default __webpack_public_path__ + "static/resume-2-48b03bc9c8e3ec3426eaf01e85c06f21.png";